import React, {useContext} from "react";
import SignInForm from "./SignIn";
import SignOutForm from "./SignUp";
import ForgotPassForm, {MigratePassModal} from "./ForgotPass";
import {AuthContext} from "contexts/auth/auth.provider";

export default function AuthenticationForm({
                                               email = '',
                                               status = '',
                                               onClose = () => {
                                               }
                                           }) {
    const {authState} = useContext<any>(AuthContext);
    let RenderForm;

    if (authState.currentForm === "signIn") {
        RenderForm = SignInForm;
    }

    if (authState.currentForm === "signUp") {
        RenderForm = SignOutForm;
    }

    if (authState.currentForm === "forgotPass") {
        RenderForm = ForgotPassForm;
    }
    if (authState.currentForm === "migratePass" || status === 'RESET_REQUIRED') {
        RenderForm = MigratePassModal;
    }
    return <RenderForm onClose={onClose} initEmail={email}/>;
}
